export default "__VITE_ASSET__CL47XQII__"